import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  commandesPardaterep,
  commandeFiltre,
} from "../actions/commandeActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useParams } from "react-router-dom";
import "../EtatPresenceClient.css";

const EtatPresenceClient = () => {
  const [dateD, setDateD] = useState(new Date());
  const [dateF, setDateF] = useState(new Date());
  const [wFilter, setWFiltre] = useState("T");
  const [rech, setRech] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { code } = useParams();

  const { commandes, loading } = useSelector(
    (state) => state.commandesListeRep
  );
  const { client } = useSelector((state) => state.client);

  // Fetch commandes based on date and filter
  useEffect(() => {
    if (wFilter === "R") {
      dispatch(commandeFiltre("Remis"));
    } else if (wFilter === "L") {
      dispatch(commandeFiltre("Livre"));
    } else {
      dispatch(commandesPardaterep(dateD, dateF, "tous"));
    }
  }, [dateD, dateF, wFilter, dispatch]);

  // Filter commandes based on search and client code
  const tabRech = useMemo(() => {
    if (!commandes) return [];
    if (rech === "") {
      return commandes.filter(
        (comm) => comm.cod_rep === client.cod_cli || comm?.cod_rep == undefined
      );
    } else {
      return commandes.filter((comm) =>
        comm.nom_cli.toUpperCase().includes(rech.toUpperCase())
      );
    }
  }, [commandes, rech, client.cod_cli]);

  const renderItem = (item) => (
    <div
      className={`commande-item ${
        item?.cod_rep == null ? "client-direct" : ""
      }`}
      onClick={() => navigate(`/CommandeDetails/${item._id}`)}
    >
      <div className="commande-name">{item.nom_cli}</div>
      <div className="commande-details">
        <div className="commande-date">
          {item.date_livraison.substring(0, 10)}{" "}
          {item.date_livraison.substring(11, 16)}
        </div>
        <div className="commande-montant">{item.totalePrix.toFixed(3)}</div>
        <div className="commande-status">
          <FontAwesomeIcon
            icon={item.cmd_remis ? faCheck : faX}
            color={item.cmd_remis ? "green" : "red"}
          />
        </div>
        <div className="commande-status">
          <FontAwesomeIcon
            icon={item.isLivree ? faCheck : faX}
            color={item.isLivree ? "green" : "red"}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className="client-info">
        <h2 className="client-title">
          {client?.nivcli_cloud === "R"
            ? "Réprésentant"
            : client?.nivcli_cloud === "F"
            ? "Client"
            : "Administrateur"}
          : {client?.nom_cli}
        </h2>
        <div className="client-row">
          <span className="client-label">Totale Commandes:</span>
          <span className="client-value">
            {commandes?.reduce((acc, i) => acc + i.totalePrix, 0)?.toFixed(3)}
          </span>
        </div>
        <div className="client-row">
          <span className="client-label">Nombre des Commandes:</span>
          <span className="client-value">{commandes?.length}</span>
        </div>
        <div className="date-pickers">
          <div className="date-picker-group">
            <label>Date Début:</label>
            <DatePicker
              selected={dateD}
              onChange={(date) => setDateD(date)}
              dateFormat="dd/MM/yyyy"
              className="date-input"
            />
          </div>
          <div className="date-picker-group">
            <label>Date Fin:</label>
            <DatePicker
              selected={dateF}
              onChange={(date) => setDateF(date)}
              dateFormat="dd/MM/yyyy"
              className="date-input"
            />
          </div>
        </div>
      </div>

      {loading && (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      )}

      <div className="filter-options">
        <label>
          <input
            type="radio"
            value="R"
            checked={wFilter === "R"}
            onChange={() => setWFiltre("R")}
            disabled={!commandes?.find((cmd) => cmd.cmd_remis)}
          />
          Remis
        </label>
        <label>
          <input
            type="radio"
            value="L"
            checked={wFilter === "L"}
            onChange={() => setWFiltre("L")}
            disabled={!commandes?.find((cmd) => cmd.isLivree)}
          />
          Livree
        </label>
        <label>
          <input
            type="radio"
            value="T"
            checked={wFilter === "T"}
            onChange={() => setWFiltre("T")}
          />
          Tous
        </label>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Taper le nom Client...."
          value={rech}
          onChange={(e) => setRech(e.target.value)}
        />
      </div>

      <div className="commandes-container">
        <div className="commandes-header">
          <div className="header-date">Date Cmd</div>
          <div className="header-montant">Montant</div>
          <div className="header-status">Rem</div>
          <div className="header-status">Livr</div>
        </div>
        <div className="commandes-list">
          {(rech === "" ? commandes : tabRech)?.map((item) => (
            <div key={item._id}>{renderItem(item)}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EtatPresenceClient;
